<template>
  <div
    class="bg-blue-200 select-none"
    @click="examBodyClick()">
    <canvas ref="myCanvas"></canvas>
    <div class="p-4 max-w-6xl mx-auto flex flex-col items-start justify-start min-h-screen">
      <div class="flex items-center justify-between h-16 w-full">
        <a
          href="/profile"
          class="w-20 sm:w-full">
          <img
            src="/img/logo-yuk-belajar-optimized.png"
            class=" sm:hidden">
          <img
            src="/img/logo-dan-nama-yuk-belajar.png"
            class="hidden sm:block">
        </a>
        <div
          v-if="sections.length && !examFinish"
          class="h-full flex items-center justify-end">
          <button
            class="rounded py-2 px-2 sm:px-4 font-bold text-white bg-blue-400 border-2 border-blue-400 shadow-md active:shadow-inner active:outline-none focus:outline-none"
            @click.stop="openReview">
            <span class="">Periksa</span>
          </button>
          <div class="w-px mx-px sm:mx-1" />
          <button
            class="rounded py-2 px-2 sm:px-4 font-bold text-white bg-blue-400 border-2 border-blue-400 shadow-md active:shadow-inner active:outline-none focus:outline-none"
            @click.stop="openSubmitWarning">
            <span class="">Kumpulkan</span>
          </button>
        </div>
      </div>
      <div class="h-px w-full my-2" />
      <div
        v-show="reviewOpen"
        class="bg-white shadow-md rounded w-full flex-grow flex flex-col items-start justify-between overflow-y-auto h-px py-2"
        @click.stop>
        <div
          v-for="sectionItem in sections"
          :key="sectionItem.id"
          class="w-full">
          <div class="relative w-full flex items-center justify-between sm:justify-start">
            <div
              class="shadow-md px-4 py-2 bg-blue-400 text-white cursor-pointer font-bold active:shadow-inner rounded-r"
              @click.stop="changeAndOpenSection(sectionItem)">
              <span class="hidden sm:inline-block">Bagian </span>
              {{ sectionItem.name }}
            </div>
          </div>
          <div class="max-w-3xl mx-auto flex-wrap flex items-center justify-center p-5 text-blue-500">
            <div
              v-for="i in sectionItem.questions"
              :key="i.id"
              class="active:outline-none shadow active:shadow-outline cursor-pointer flex-shrink-0 border-2 border-white rounded-full w-6 h-6 text-center mr-2 mb-2"
              :class="{
                'bg-white border-white' : isQuestionAnswered(i),
                'border-blue-500' : !isQuestionMarked(i) && !isQuestionAnswered(i),
                'border-yellow-600 text-yellow-600': isQuestionMarked(i) && !isQuestionAnswered(i),
                'border-yellow-600 bg-yellow-600 text-white': isQuestionMarked(i) && isQuestionAnswered(i),
                'shadow-outline': i == question,
              }"
              @click="changeAndOpenQuestion(i)">
              <span class="inline-block align-middle font-bold text-2xs">{{ sectionItem.questions.indexOf(i) + 1 }}</span><br>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="submitWarningOpen && !examFinish"
        class="bg-white shadow-md rounded w-full flex-grow py-2 px-4 overflow-y-auto h-px"
        @click.stop>
        <div class="max-w-lg mx-auto text-center text-gray-800 leading-normal">
          <div class="font-bold text-xl py-4">
            Kamu hendak mengumpulkan dan mengakhiri ujian.
          </div>
          <template v-if="totalUnanswered">
            <div class="w-full h-px my-2" />
            <div><span class="font-bold">Peringatan!</span> Masih ada <span class="font-bold">{{ totalUnanswered }} soal</span> yang <span class="font-bold">belum dijawab</span>. Klik tombol <span class="font-bold">Periksa</span> di atas untuk melihat soal mana yang belum terjawab.</div>
          </template>
          <div class="w-full h-px my-2" />
          <div>Selama masih ada sisa waktu, kamu masih bisa memeriksa soal yang kamu kerjakan.</div>
          <div class="w-full h-px my-2" />
          <div>Apakah kamu yakin ingin mengumpulkan dan mengakhiri ujian sekarang?</div>
          <div class="w-full h-px my-6" />
          <div class="flex items-center justify-center">
            <button
              class="rounded py-1 px-4 font-bold text-white border-2 border-blue-500 shadow-md active:shadow-inner active:outline-none focus:outline-none text-blue-500"
              @click.stop="cancelSubmit()">
              <span class="">Batalkan</span>
            </button>
            <div class="w-px h-px mx-1" />
            <button
              :disabled="$store.state.loading"
              class="rounded py-1 px-5 sm:px-6 font-bold text-white bg-blue-600 border-2 border-blue-600 shadow-md active:shadow-inner active:outline-none focus:outline-none disabled:opacity-75 disabled:cursor-not-allowed disabled:shadow-none"
              @click.stop="submit()">
              <span class="">Ya, kumpulkan</span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-show="instructionOpen"
        class="bg-white shadow-md rounded w-full flex-grow py-2 px-4 overflow-y-auto h-px"
        @click.stop>
        <div class="max-w-lg mx-auto text-center text-gray-800 leading-normal">
          <div class="font-bold text-xl py-4">
            Petunjuk
          </div>
          <div class="w-full h-px my-2" />
          <div>Klik tombol <span class="font-bold">Periksa</span> untuk melihat status terisinya jawaban untuk tiap soal.</div>
          <div class="w-full h-px my-2" />
          <div>Nama bagian soal dapat diklik untuk berpindah bagian.</div>
          <div class="w-full h-px my-2" />
          <div>Klik tombol <span class="font-bold">Kumpulkan</span> kemudian konfirmasi dengan klik tombol <span class="font-bold">Ya, kumpulkan</span> untuk mengumpulkan dan menyelesaikan tes.</div>
          <div class="w-full h-px my-6" />
          <div class="flex items-center justify-center">
            <button
              class="rounded py-1 px-4 font-bold text-white border-2 border-blue-500 shadow-md active:shadow-inner active:outline-none focus:outline-none text-blue-500"
              @click.stop="cancelSubmit()">
              <span class="">Kembali ke soal</span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-show="examFinish"
        class="bg-white shadow-md rounded w-full flex-grow py-2 px-4">
        <div class="max-w-lg mx-auto text-center text-gray-800 leading-normal">
          <div class="font-bold text-xl py-4">
            Pekerjaanmu telah berhasil dikumpulkan.
          </div>
          <div class="w-full h-px my-2" />
          <div>Pekerjaanmu kini sedang mengantri untuk dikoreksi. Setelah selesai dikoreksi, kamu dapat melihat hasil koreksi jawaban <span class="italic">Olimpiade</span>-mu di halaman Akun.</div>
          <div class="w-full h-px my-6" />
          <a
            href="/profile"
            class="inline-block shadow-md active:outline-none active:shadow-inner rounded py-2 px-2 sm:px-4 font-bold text-white bg-blue-500 border-2 border-blue-500 focus:outline-none">
            <svg
              id="person-icon"
              class="w-6 h-6 fill-current inline-block mr-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z" /></svg>
            Buka Halaman Akun
          </a>
          <div class="w-full h-px my-6" />
          <template v-if="primaryExam != null && primaryExam.sponsors && primaryExam.sponsors.length && primaryExam.sponsors.findIndex((el) => el.is_after_module) >= 0">
            <div
              v-for="sponsor in primaryExam.sponsors"
              :key="sponsor.id"
              class="mx-auto w-full sm:flex items-center justify-center sm:space-x-10">
              <a
                v-if="sponsor.is_after_module"
                class="w-full sm:w-1/2"
                target="_blank"
                rel="nofollow"
                :href="sponsor.url">
                <img
                  :src="'/storage/' + sponsor.picture"
                  :alt="sponsor.name">
              </a>
            </div>
          </template>
        </div>
      </div>
      <div
        v-show="questionOpen"
        class="bg-white shadow-md rounded w-full flex-grow flex flex-col items-start justify-between py-2">
        <template v-if="sections.length == 0">
          <div class="w-32 h-32 text-blue-300 mx-auto my-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="fill-current"
              viewBox="0 0 512 512"><path d="M256,368a16,16,0,0,1-7.94-2.11L108,285.84a8,8,0,0,0-12,6.94V368a16,16,0,0,0,8.23,14l144,80a16,16,0,0,0,15.54,0l144-80A16,16,0,0,0,416,368V292.78a8,8,0,0,0-12-6.94L263.94,365.89A16,16,0,0,1,256,368Z" /><path d="M495.92,190.5s0-.08,0-.11a16,16,0,0,0-8-12.28l-224-128a16,16,0,0,0-15.88,0l-224,128a16,16,0,0,0,0,27.78l224,128a16,16,0,0,0,15.88,0L461,221.28a2,2,0,0,1,3,1.74V367.55c0,8.61,6.62,16,15.23,16.43A16,16,0,0,0,496,368V192A14.76,14.76,0,0,0,495.92,190.5Z" /></svg>
          </div>
        </template>
        <template v-if="sections.length && !examFinish">
          <div class="relative w-full flex items-center justify-between sm:justify-start">
            <div
              v-if="section != null"
              class="shadow-md px-4 py-2 bg-blue-400 text-white cursor-pointer font-bold active:shadow-inner rounded-r"
              @click.stop="openSectionMenu()">
              <span class="hidden sm:inline-block">Bagian </span>
              {{ section.name }}
            </div>
            <div class="hidden sm:block w-px h-5 -ml-px mt-px bg-blue-400" />
            <div
              class="w-40 sm:w-auto px-3 py-2 text-right sm:text-left"
              :class="{'text-yellow-600': isQuestionMarked(question)}">
              Soal <span class="sm:hidden">No.</span><span class="hidden sm:inline-block">Nomor</span> {{ getQuestionNumber(question) }}
            </div>
            <div
              v-show="sectionMenuOpen && $store.state.dropdownOpen"
              class="block absolute mt-10 top-0 left-0 bg-blue-400 text-white rounded-r shadow-md py-1">
              <div
                v-for="sectionItem in sections"
                :key="sectionItem.id"
                class="px-4 py-3 cursor-pointer font-bold hover:bg-blue-500 active:bg-blue-600"
                @click="changeSection(sectionItem)">
                {{ sectionItem.name }}
              </div>
            </div>
          </div>
          <div class="h-px my-1 mt-4 md:mt-5 w-full" />
          <div
            v-if="question != null"
            class="flex-grow overflow-y-auto h-px w-full max-w-3xl text-md md:text-lg mx-auto px-4 leading-tight font-serif text-gray-900">
            <div
              v-if="question.reference != null"
              class="mb-5">
              <button
                v-if="!referenceOpen"
                class="mx-auto p-3 rounded shadow bg-gray-300 flex items-center justify-start font-sans font-bold focus:outline-none active:shadow-inner active:bg-gray-200"
                @click="openReference()">
                <div class="w-6 h-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current"
                    viewBox="0 0 512 512"><path
                      d="M416,221.25V416a48,48,0,0,1-48,48H144a48,48,0,0,1-48-48V96a48,48,0,0,1,48-48h98.75a32,32,0,0,1,22.62,9.37L406.63,198.63A32,32,0,0,1,416,221.25Z"
                      style="fill:none;stroke:#000;stroke-linejoin:round;stroke-width:32px" /><path
                        d="M256,56V176a32,32,0,0,0,32,32H408"
                        style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /><line
                          x1="176"
                          y1="288"
                          x2="336"
                          y2="288"
                          style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /><line
                            x1="176"
                            y1="368"
                            x2="336"
                            y2="368"
                            style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /></svg>
                </div>
                <div class="ml-1">
                  Buka Konteks
                </div>
              </button>
              <button
                v-if="referenceOpen"
                class="mx-auto p-3 rounded shadow-inner bg-gray-200 flex items-center justify-start font-sans font-bold focus:outline-none active:shadow active:bg-gray-300 mb-5"
                @click="closeReference()">
                <div class="w-6 h-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current"
                    viewBox="0 0 512 512"><title>ionicons-v5-m</title><path
                      d="M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256Z"
                      style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:32px" /><line
                        x1="320"
                        y1="320"
                        x2="192"
                        y2="192"
                        style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /><line
                          x1="192"
                          y1="320"
                          x2="320"
                          y2="192"
                          style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px" /></svg>
                </div>
                <div class="ml-1">
                  Tutup Konteks
                </div>
              </button>
              <div
                v-if="referenceOpen"
                class="reference"
                v-html="removeLink(question.reference.content)" />
            </div>
            <div
              class="question"
              v-html="removeLink(question.content)" />
            <div class="h-px my-1 w-full" />
            <template v-if="section.type == 'multiple'">
                <div
                v-for="i in question.answers"
                :key="i.id"
                class="flex items-center justify-start mb-2 cursor-pointer"
                @click="chooseAnswer(i)">
                <div
                    class="flex-shrink-0 h-4 w-5 border-2 border-gray-800 rounded-full"
                    :class="{
                    'bg-gray-800': question.chosenAnswer == i,
                    'border-yellow-600': isQuestionMarked(question),
                    'bg-yellow-600': isQuestionMarked(question) && question.chosenAnswer == i,
                    }" />
                <div class="w-px h-px flex-shrink-0 mx-2" />
                <div v-html="removeLink(i.content)" />
                </div>
            </template>
            <template v-if="section.type == 'short_answer'">
                <div
                v-for="i in question.answers"
                :key="i.id"
                class="flex items-center justify-start mb-2 cursor-pointer"
                @click="chooseAnswer(i)">
                <div
                    class="flex-shrink-0 h-4 w-5 border-2 border-gray-800 rounded-full"
                    :class="{
                    'bg-gray-800': question.chosenAnswer != null,
                    'border-yellow-600': isQuestionMarked(question),
                    'bg-yellow-600': isQuestionMarked(question) && question.chosenAnswer != null,
                    }" />
                <div class="w-px h-px flex-shrink-0 mx-2" />
                    <input
                        v-model.lazy="short_answer"
                        class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline">
                </div>
            </template>
          </div>
          <div class="h-px my-1 w-full" />
          <div class="w-full flex items-center justify-center text-xs sm:text-sm">
            <button
              v-show="!questionNumberMarked"
              class="shadow-md active:outline-none active:shadow-inner rounded py-2 px-2 sm:px-4 font-bold text-blue-500 bg-white border-2 border-blue-500 focus:outline-none"
              @click="markQuestion()">
              <span class="">Beri Tanda</span>
            </button>
            <button
              v-show="questionNumberMarked"
              class="shadow-md active:outline-none active:shadow-inner rounded py-2 px-2 sm:px-4 font-bold text-blue-500 bg-white border-2 border-blue-500 focus:outline-none"
              @click="unmarkQuestion()">
              <span class="">Hapus Tanda</span>
            </button>
            <div class="w-px mx-px sm:mx-1" />
            <button
              class="shadow-md active:outline-none active:shadow-inner rounded py-2 px-2 sm:px-4 font-bold text-blue-500 bg-white border-2 border-blue-500 focus:outline-none"
              @click="changeToPreviousQuestion()">
              <span class="">Sebelumnya</span>
            </button>
            <div class="w-px mx-px sm:mx-1" />
            <button
              class="shadow-md active:outline-none active:shadow-inner rounded py-2 px-2 sm:px-4 font-bold text-white bg-blue-500 border-2 border-blue-500 focus:outline-none"
              @click="changeToNextQuestion()">
              <span class="">Selanjutnya</span>
            </button>
          </div>
        </template>
      </div>
      <div class="h-px w-full my-2" />
      <div class="flex items-center justify-between h-12 w-full text-blue-500">
        <template v-if="sections.length && !examFinish">
          <div
            v-show="!questionOpen"
            class="min-h-full w-3/4 flex flex-col items-start justify-between" />
          <div
            v-show="questionOpen"
            class="min-h-full w-3/4 flex flex-col items-start justify-between">
            <div class="font-bold text-sm">
              Nomor Soal:
            </div>
            <div class="w-full -ml-1 p-1 flex items-start justify-start overflow-x-auto">
              <div
                v-for="i in questions"
                :key="i.id"
                class="active:outline-none shadow active:shadow-outline cursor-pointer flex-shrink-0 border-2 border-white rounded-full w-6 h-6 text-center mr-2"
                :class="{
                  'bg-white border-white' : isQuestionAnswered(i),
                  'border-blue-500' : !isQuestionMarked(i) && !isQuestionAnswered(i),
                  'border-yellow-600 text-yellow-600': isQuestionMarked(i) && !isQuestionAnswered(i),
                  'border-yellow-600 bg-yellow-600 text-white': isQuestionMarked(i) && isQuestionAnswered(i),
                  'shadow-outline': i == question,
                }"
                @click="changeQuestion(i)">
                <span class="inline-block align-middle font-bold text-2xs">{{ getQuestionNumber(i) }}</span>
              </div>
            </div>
          </div>
          <div class="min-h-full w-1/3 flex flex-col items-end justify-between pb-1">
            <template v-if="initialCountDown != 0">
              <countdown
                :time="initialCountDown"
                class="font-bold text-sm"
                :transform="formatCountdown">
                <template #default="props">
                  {{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}
                </template>
              </countdown>
            </template>
            <div
              class="cursor-pointer rounded py-1 px-2 font-bold  text-xs text-white bg-blue-400 border-2 border-blue-400 shadow-md active:shadow-inner active:outline-none"
              @click.stop="openInstruction">
              Petunjuk
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['user_id', 'module_id', 'exam_id', 'user_product_detail_id'],
  data: function() {
    return {
      initialCountDown: 0,
      timeRemaining: 5 * 60 * 60 * 1000,
      sectionMenuOpen: false,
      questionOpen: true,
      reviewOpen: false,
      instructionOpen: false,
      submitWarningOpen: false,
      section: null,
      question: null,
      questionStorageKey: null,
      timeStorageKey: null,
      referenceOpen: false,
      examFinish: false,
      short_answer: null,
      canvasWidth: 400,
      canvasHeight: 200,
      change_tab_counter:0,
    };
  },
  computed: {
    ...mapState(['primaryExam']),
    totalUnanswered() {
      let totalUnanswered = 0;
      for (let i = 0; i < this.sections.length; i++) {
        let section = this.sections[i];
        for (let j = 0; j < section.questions.length; j++) {
          let question = section.questions[j];
          if (question.chosenAnswer == null) {
            totalUnanswered++;
          }
        }
      }

      return totalUnanswered;
    },
    module() {
      return this.$store.state.module;
    },
    sections() {
      return this.$store.state.questionBySection;
    },
    questions() {
      return this.section != null ? this.section.questions : [];
    },
    firstSection() {
      return this.$store.state.questionBySection.length ? this.$store.state.questionBySection[0] : null;
    },
    dropdownOpen() {
      return this.$store.state.dropdownOpen;
    },
    questionNumberMarked() {
      if (this.question == null) {
        return false;
      }
      return this.question.isMarked;
    },
  },
  watch: {
    dropdownOpen(newStateOpen, oldStateOpen) {
      if (!newStateOpen && oldStateOpen && this.questionOpen) {
        this.sectionMenuOpen = false;
      }
    },
    firstSection(newFirstSection, oldFirstSection) {
      if (newFirstSection != null) {
        let section = newFirstSection;
        for (let i = 0; i < this.sections.length; i++) {
          if (this.sections[i].isCurrentSection) {
            section = this.sections[i];
            break;
          }
        }
        this.section = section;
        if (this.section.currentQuestion != null) {
          this.question = this.section.currentQuestion;
        } else {
          this.question = newFirstSection.questions[0];
        }
        if (this.section.type == 'short_answer') {
          this.short_answer = this.section.currentQuestion.chosenAnswer.is_solution;
        }
      }
    },
    module(newModule, oldModule) {
      if (newModule != null) {
        this.initialCountDown = this.getTimeRemaining();
        this.timeRemaining = this.getTimeRemaining();
      }
    },
    timeRemaining(newTimeRemaining, oldTimeRemaining) {
      if (newTimeRemaining <= 0) {
        this.submit();
      }
    },
  },
  async mounted() {
    this.questionStorageKey = [
      this.user_id,
      this.module_id,
      this.exam_id,
    ].join('_');

    this.timeStorageKey = [
      this.user_id,
      this.module_id,
      this.exam_id,
      'time',
    ].join('_');

    this.$store.commit('setLoading', false);
    // Disable text copying
    document.addEventListener('copy', this.preventCopy);
    // Disable text paste
    document.addEventListener('paste', this.preventPaste);
    //activating canvas
    this.renderCanvasText();
    //change tab
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            console.log('Tab is not active');
            this.change_tab_counter++;
        } else {
            console.log('Tab is active');
        }
    });
    //blur and focus
    window.addEventListener('blur', () => {
        console.log('Tab is inactive');
        this.change_tab_counter++;
    });

    window.addEventListener('focus', () => {
    console.log('Tab is active');
    });
  },
  created() {
    this.countDownTimeRemaining();
  },
  methods: {
    openReference() {
      this.referenceOpen = true;
    },
    closeReference() {
      this.referenceOpen = false;
    },
    removeLink(htmlString) {
      return htmlString.replace(/<a\b[^>]*>/g,'').replace(/<\/a>/g, '');
    },
    formatCountdown(props) {
      Object.entries(props).forEach(([key, value]) => {
        if (key == 'minutes' || key == 'seconds') {
          const newValue = value < 10 ? `0${value}` : value;
          props[key] = newValue;
        }
      });

      return props;
    },
    blur() {
      window.document.activeElement.blur();
    },
    openSectionMenu() {
      this.sectionMenuOpen = this.sectionMenuOpen ? false : true;
      this.$store.commit('setDropdownOpen', this.sectionMenuOpen);
    },
    openReview() {
      this.closeAll();
      this.reviewOpen = true;
    },
    openSubmitWarning() {
      if (this.section.type == 'short_answer' && this.short_answer != null) {
        this.question.chosenAnswer.is_solution = this.short_answer;
      }
      this.syncLocalStorage();
      this.closeAll();
      this.submitWarningOpen = true;
    },
    openInstruction() {
      this.closeAll();
      this.instructionOpen = true;
    },
    chooseAnswer(answer) {
      this.question.chosenAnswer = answer;
      this.syncLocalStorage();
    },
    changeSection(section) {
      this.section = section;
      if (!this.section.isCurrentSection) {
        for (let i = 0; i < this.sections.length; i++) {
          this.sections[i].isCurrentSection = false;
        }
        this.section.isCurrentSection = true;
      }
      if (this.section.currentQuestion == null) {
        this.section.currentQuestion = this.section.questions[0];
      }
      if (this.section.currentQuestion != this.question) {
        this.changeQuestion(this.section.currentQuestion);
      }
      this.syncLocalStorage();
    },
    changeAndOpenSection(section) {
      this.changeSection(section);
      this.openQuestionCloseOther();
    },
    getQuestionNumber(question) {
      return this.questions.indexOf(question) + 1;
    },
    changeQuestion(question) {
      if (this.section.type == 'short_answer' && this.short_answer != null) {
        // this.chooseAnswer(this.short_answer);
        this.question.chosenAnswer.is_solution = this.short_answer;
      }
      this.referenceOpen = false;
      this.question = question;
      if (this.section.questions.indexOf(this.question) == -1) {
        for (let i = 0; i < this.sections.length; i++) {
          if (this.sections[i].questions.indexOf(this.question) != -1) {
            this.sections[i].currentQuestion = question;
            this.changeSection(this.sections[i]);
            break;
          }
        }
      } else {
        this.section.currentQuestion = this.question;
      }

      if (this.isQuestionAnswered(this.question)) {
        this.short_answer = this.question.chosenAnswer.is_solution;
      } else {
        this.short_answer = null;
      }
      this.syncLocalStorage();
    },
    changeAndOpenQuestion(question) {
      this.changeQuestion(question);
      this.openQuestionCloseOther();
    },
    changeToNextQuestion() {
      let questionNumber = this.getQuestionNumber(this.question);
      if (questionNumber < this.section.questions.length) {
        this.changeQuestion(this.questions[questionNumber - 1 + 1]);
      } else {
        let indexOfSection = this.sections.indexOf(this.section);
        if (indexOfSection < this.sections.length - 1) {
          this.changeQuestion(this.sections[indexOfSection + 1].questions[0]);
        }
      }
    },
    changeToPreviousQuestion() {
      let questionNumber = this.getQuestionNumber(this.question);
      if (questionNumber > 1) {
        this.changeQuestion(this.questions[questionNumber - 1 - 1]);
      } else {
        let indexOfSection = this.sections.indexOf(this.section);
        if (indexOfSection > 0) {
          let questions = this.sections[indexOfSection - 1].questions;
          this.changeQuestion(questions[questions.length - 1]);
        }
      }
    },
    isQuestionMarked(question) {
      if (question == null) {
        return false;
      }
      return question.isMarked;
    },
    isQuestionAnswered(question) {
      return question.chosenAnswer != null;
    },
    markQuestion() {
      this.question.isMarked = true;
      this.syncLocalStorage();
    },
    unmarkQuestion() {
      this.question.isMarked = false;
      this.syncLocalStorage();
    },
    examBodyClick() {
      if (!this.questionOpen) {
        this.openQuestionCloseOther();
      }
    },
    openQuestionCloseOther() {
      this.questionOpen = true;
      this.reviewOpen = this.submitWarningOpen = this.instructionOpen = false;
    },
    closeAll() {
      this.questionOpen = this.reviewOpen = this.submitWarningOpen = this.instructionOpen = false;
    },
    async submit() {
      this.$store.commit('setLoading', true);
      let questions = window._.flatMap(this.sections, 'questions');
      let payload = {
        answerData: window._.map(questions, function(question) {
          return question.chosenAnswer != null
            ? question.chosenAnswer.question_answer_id
            : null;
        }).filter(function(item) {
          return item != null;
        }),
        shortAnswerData: window._.map(questions, function(question) {
          if (question.chosenAnswer != null) {
            return {
                'question_answer_id':question.chosenAnswer.question_answer_id,
                'short_answer':question.chosenAnswer.is_solution,
            };
          }else{
            return null;
          }
        }).filter(function(item) {
          return item != null;
        }),
        module_id:this.module_id,
        exam_id:this.exam_id,
        user_product_detail_id:this.user_product_detail_id,
        change_tab_counter:this.change_tab_counter,
      };

      try {
        let response = await axios.post('/submit-exam', payload);
        if (response.data.status == false) {
            this.$store.commit('setLoading', false);
            alert('Maaf! '+response.data.msg)
        } else {
            window.localStorage.removeItem(this.questionStorageKey);
            window.localStorage.removeItem(this.timeStorageKey);
            this.examFinish = true;
        }

      } catch (error) {
        this.$store.commit('setLoading', false);
        throw error;
      }

      this.$store.commit('setLoading', false);
    },
    backToProfile() {
      window.location.href = '/profile';
    },
    cancelSubmit() {
      this.closeAll();
      this.questionOpen = true;
    },
    syncLocalStorage() {
      window.localStorage.setItem(this.questionStorageKey, JSON.stringify(this.$store.state.questionBySection));
    },
    getTimeRemaining() {
      return this.module.duration * 60 * 1000 - this.getTimeElapsed();
    },
    getTimeElapsed() {
      if (this.$store.state.module == null) {
        return 0;
      } else {
        let started_at = Vue.moment(this.$store.state.module.pivot.started_at);
        let now = this.$store.state.now;
        let introductionTime = 45000
        let timeElapsed = now - started_at - introductionTime;
        return timeElapsed;
      }
    },
    countDownTimeRemaining() {
      if (this.timeRemaining > 0) {
        setTimeout(() => {
          this.timeRemaining -= 1000;
          window.localStorage.setItem(this.timeStorageKey, this.timeRemaining);
          this.countDownTimeRemaining();
        }, 1000)
      }
    },
    preventCopy(event) {
      event.preventDefault();
      alert('Copying is disabled on this page!');
    },
    preventPaste(event) {
      event.preventDefault();
      alert('Pasting is disabled on this page!');
    },
    renderCanvasText() {
      // Access the canvas element using the 'ref' attribute
      const canvas = this.$refs.myCanvas;
      const ctx = canvas.getContext('2d');

      // Set font properties
      ctx.font = '30px Arial';

      // Set text color
      ctx.fillStyle = 'black';

      // Draw text on the canvas
      //ctx.fillText('This is a test rendered on canvas', 1, 50);
    }
  }
}
</script>
<style>
    .attachment__caption {
        display: none;
    }
    .question figure.attachment, .reference figure.attachment {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    .question div, .reference div {
        margin-bottom: 0.75rem;
    }
</style>
